import { RouterChild } from '@/router';

export default [
  { name: 'car-calendar', path: 'car/calendar', component: () => import('./views/Calendar.vue') } as RouterChild
];
